import Cookies from 'js-cookie';
import { gsap } from 'gsap';

export default {

	selectors: {
		popup: '.popup',
		backdrop: '.popup__backdrop',
		content: '.popup__content',
	},

	classes: {
		hidden: 'hidden',
	},

	popup: null,

	init() {
		this.popup = document.querySelector(this.selectors.popup);
		const cookie = Cookies.get(this.cookieName());
		const delay = this.popup.dataset.delay ? parseInt(this.popup.dataset.delay, 10) : 8000;

		document.querySelector(this.selectors.backdrop).addEventListener('click', () => {
			this.hide();
		});

		if (this.popup.querySelector('a')) {
			this.popup.querySelector('a').addEventListener('click', () => {
				this.hide();
			});
		}

		if (cookie !== 'true') {
			setTimeout(() => {
				this.show();
			}, delay);
		}
	},

	cookieName() {
		return `popup_${this.popup.dataset.popupId}`;
	},

	show() {
		gsap.to(this.popup, { autoAlpha: 1, visibility: 'visible' });
	},

	hide() {
		const expires = this.popup.dataset.expires ? parseInt(this.popup.dataset.expires, 10) : 21;
		Cookies.set(this.cookieName(), 'true', { expires });
		gsap.to(this.popup, { autoAlpha: 0, visibility: 'hidden' });
	},

};
